/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Timeline_No_IncidentInputs */

const en_cases_timeline_no_incident = /** @type {(inputs: Cases_Timeline_No_IncidentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Incident Date`)
};

const pt_br2_cases_timeline_no_incident = /** @type {(inputs: Cases_Timeline_No_IncidentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem Data do Sinistro`)
};

/**
* | output |
* | --- |
* | "No Incident Date" |
*
* @param {Cases_Timeline_No_IncidentInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_timeline_no_incident = /** @type {((inputs?: Cases_Timeline_No_IncidentInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Timeline_No_IncidentInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_timeline_no_incident(inputs)
	return pt_br2_cases_timeline_no_incident(inputs)
});